import React, { useState } from 'react';
import { useImages } from '../../hooks/useImages';

function ImagePicker({ onSelect, onClose }) {
  const { images, loading, uploadImage } = useImages();
  const [search, setSearch] = useState('');
  const [uploading, setUploading] = useState(false);

  const filtered = images.filter(img =>
    img.name.toLowerCase().includes(search.toLowerCase())
  );

  const handleUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    setUploading(true);
    try {
      const img = await uploadImage(file);
      onSelect(img.path);
    } catch {
      alert('Erreur lors de l\'upload');
    } finally {
      setUploading(false);
    }
  };

  return (
    <div style={{
      position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
      background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center',
      justifyContent: 'center', zIndex: 1000
    }} onClick={onClose}>
      <div style={{
        background: 'white', borderRadius: '8px', width: '90%', maxWidth: '800px',
        maxHeight: '80vh', display: 'flex', flexDirection: 'column'
      }} onClick={e => e.stopPropagation()}>
        <div style={{ padding: '16px 20px', borderBottom: '1px solid #eee', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <h2 style={{ margin: 0, fontSize: '18px' }}>Choisir une image</h2>
          <button onClick={onClose} style={{ background: 'none', border: 'none', fontSize: '20px', cursor: 'pointer', color: '#666' }}>×</button>
        </div>

        <div style={{ padding: '12px 20px', borderBottom: '1px solid #eee', display: 'flex', gap: '12px' }}>
          <input
            type="text"
            placeholder="Rechercher..."
            value={search}
            onChange={e => setSearch(e.target.value)}
            style={{ flex: 1, padding: '8px 12px', border: '1px solid #ddd', borderRadius: '4px', fontSize: '14px' }}
          />
          <label style={{
            background: '#32afe5', color: 'white', padding: '8px 16px',
            borderRadius: '4px', cursor: 'pointer', fontSize: '14px', whiteSpace: 'nowrap'
          }}>
            {uploading ? 'Upload...' : 'Uploader'}
            <input type="file" accept="image/*" onChange={handleUpload} style={{ display: 'none' }} />
          </label>
        </div>

        <div style={{ flex: 1, overflow: 'auto', padding: '16px 20px' }}>
          {loading ? (
            <p>Chargement...</p>
          ) : (
            <div style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fill, minmax(120px, 1fr))',
              gap: '12px'
            }}>
              {filtered.map(img => (
                <div
                  key={img.path}
                  onClick={() => onSelect(img.path)}
                  style={{
                    cursor: 'pointer', borderRadius: '6px', overflow: 'hidden',
                    border: '2px solid transparent', transition: 'border-color 0.2s'
                  }}
                  onMouseEnter={e => e.currentTarget.style.borderColor = '#32afe5'}
                  onMouseLeave={e => e.currentTarget.style.borderColor = 'transparent'}
                >
                  <div style={{ height: '100px', background: '#f5f5f5' }}>
                    <img src={img.path} alt={img.name}
                      style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                      loading="lazy"
                    />
                  </div>
                  <div style={{ padding: '4px 6px', fontSize: '11px', color: '#666', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                    {img.name}
                  </div>
                </div>
              ))}
            </div>
          )}
          {!loading && filtered.length === 0 && (
            <p style={{ textAlign: 'center', color: '#888', padding: '20px' }}>Aucune image trouvée</p>
          )}
        </div>
      </div>
    </div>
  );
}

export default ImagePicker;
